import React from "react";
import "./Partners.scss";

import gridBg from "../../../assets/images/home/07-partners/grid.png";

import logoMinds from "../../../assets/images/home/07-partners/logo-minds.svg";
import logoNewCampus from "../../../assets/images/home/07-partners/logo-new-campus-2.svg";
import logoGeeks from "../../../assets/images/home/07-partners/logo-geeks-of-gurukul.svg";
import logoLuvia from "../../../assets/images/home/07-partners/logo-luvia.svg";
import logoAnimoca from "../../../assets/images/home/07-partners/logo-animoca.svg";
import logoTinyTap from "../../../assets/images/home/07-partners/logo-tiny-tap-2.svg";
import logoBinance from "../../../assets/images/home/07-partners/logo-binance-labs-2.svg";
import logoGoodwall from "../../../assets/images/home/07-partners/logo-goodwall.svg";
import logoPreferrd from "../../../assets/images/home/07-partners/logo-preferrd.svg";
import logoHackquest from "../../../assets/images/home/07-partners/logo-hackquest-2.svg";
import logoMogaland from "../../../assets/images/home/07-partners/logo-mogaland.svg";
import logoAnichess from "../../../assets/images/home/07-partners/logo-anichess.svg";
import logoAir from "../../../assets/images/home/07-partners/logo-air.svg";
import logoMoca from "../../../assets/images/home/07-partners/logo-moca-chain.svg";
import logoRiseIn from "../../../assets/images/home/07-partners/logo-rise-in-2.svg";

// 15 partner logos in the centre 5×3 band (Figma Frame 2147225829).
// `w` is the Figma logo width (px). Tile fill colour comes from grid.png
// (#F7F8FF frosted tiles), not from CSS, so it matches the export exactly.
const LOGOS = [
  { src: logoAnimoca, alt: "Animoca Brands", w: 94 },
  { src: logoMinds, alt: "Minds", w: 116 },
  { src: logoNewCampus, alt: "New Campus", w: 90 },
  { src: logoGeeks, alt: "Geeks of Gurukul", w: 107 },
  { src: logoLuvia, alt: "Luvia", w: 100 },
  { src: logoRiseIn, alt: "Rise In", w: 110 },
  { src: logoTinyTap, alt: "TinyTap", w: 60 },
  { src: logoBinance, alt: "Binance Labs", w: 106 },
  { src: logoGoodwall, alt: "Goodwall", w: 89 },
  { src: logoPreferrd, alt: "Preferrd", w: 110 },
  { src: logoHackquest, alt: "Hackquest", w: 120 },
  { src: logoMogaland, alt: "Mogaland", w: 121 },
  { src: logoAnichess, alt: "Anichess", w: 143 },
  { src: logoAir, alt: "Air", w: 82 },
  { src: logoMoca, alt: "Moca Chain", w: 110 },
];

export default function Partners() {
  return (
    <section className="partners">
      <div className="partners__stage">
        {/* Figma Grid.png @2x — frosted #F7F8FF tiles + elliptical fade */}
        <img
          className="partners__grid-bg"
          src={gridBg}
          alt=""
          aria-hidden="true"
          draggable={false}
        />

        <div className="partners__logos">
          {LOGOS.map((logo) => (
            <div className="partners__tile partners__tile--logo" key={logo.alt}>
              <img
                src={logo.src}
                alt={logo.alt}
                loading="lazy"
                style={{ width: `${logo.w}px` }}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="partners__heading">
        <h2>Built with leading education and ecosystem partners</h2>
        <p>
          Open Campus works with partners across learning, credentials,
          infrastructure and career growth.
        </p>
      </div>
    </section>
  );
}
